import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const adminAccessCompany = async (params = {}) => {
    return await api.post(`/v1/admin/companyAccessByAdmin`, params);
};
export const getCompanyInformationForAdmin = async (params = {}) => {
    return await api.post(`/v1/admin/getCompanyInformationForAdmin`, params);
};

export const compressedImage = async (params = {}) => {
    return await apiFormData.post(
        "/v1/image/compressedImage",
        params, { responseType: 'blob' }
    );
};

export const dropdownEmployee = async (params = {}) => {
    return await api.post("/v1/dropdown/getEmployee", params);
};

export const updateCompanyAdmin = async (params = {}) => {
    return await apiFormData.post("/v1/admin/updateCompanyForAdmin", params);
};

export const enabledAdminCompany = async (params = {}) => {
    return await api.post("/v1/admin/updateCompanyStatusFlag", params);
};

export const getCompanyPaginationForAdmin = async (params = {}) => {
    return await api.post("/v1/admin/getCompanyPaginationForAdmin", params);
};

export const getTaxCompany = async (params = {}) => {
    return await api.post("/v1/dropdown/taxCompany", params);
};

export const createCompany = async (params = {}) => {
    return await apiFormData.post("/v1/company/createCompany", params, {
        isFormData: true,
    });
};

export const dropdownUserAdmin = async (params = {}) => {
    return await api.post("/v1/admin/getDropdownStmUserAdmin", params);
};